module.exports = "<div class=\"radio\">\n  <label class=\"form-check-label\">\n    <input name=\"alarmFilterRadios\" (change)=\"onChange($event)\" value=\"{{ label }}\" type=\"radio\" [checked]=\"checked\" />\n    <span>{{ label }}</span>\n  </label>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/filter/filter-item/park-filter-item.html
// module id = ./src/app/dashboard/parks/park/filter/filter-item/park-filter-item.html
// module chunks = main